import { LOCAL_STORAGE_KEYS } from 'constant';
import {
  TIMESHEET_END_DATE_KEY,
  TIMESHEET_PROJECT_KEY,
  TIMESHEET_START_DATE_KEY,
} from 'pages/Timesheet/common/localStorageKeys';

export const removeLocalStorageItemOnLogout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('tenant');
  localStorage.removeItem(TIMESHEET_PROJECT_KEY);
  localStorage.removeItem('gettingStartedModalShown');
  localStorage.removeItem('addprojectWidgetShown');
  localStorage.removeItem('payrunWidgetShown');
  localStorage.removeItem('customFormWidgetShown');
  localStorage.removeItem('supplier');
  localStorage.removeItem('multiProject');
  localStorage.removeItem('multiDocketProject');
  localStorage.removeItem('multiDocketSupplier');
  localStorage.removeItem('date');
  localStorage.removeItem('status');
  localStorage.removeItem('isNPSGuideShown');
  localStorage.removeItem(LOCAL_STORAGE_KEYS.BILL_MISMATCH_ALERT);
  localStorage.removeItem(TIMESHEET_START_DATE_KEY);
  localStorage.removeItem(TIMESHEET_END_DATE_KEY);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.DCT_FILTERS);

  window.open('/login', '_self');
};

export const removeTimeSheetProject = () => {
  localStorage.removeItem(TIMESHEET_PROJECT_KEY);
  localStorage.removeItem('gettingStartedModalShown');
  localStorage.removeItem('addprojectWidgetShown');
  localStorage.removeItem('payrunWidgetShown');
  localStorage.removeItem('customFormWidgetShown');
  localStorage.removeItem('supplier');
  localStorage.removeItem('multiProject');
  localStorage.removeItem('multiDocketProject');
  localStorage.removeItem('multiDocketSupplier');
  localStorage.removeItem('status');
  localStorage.removeItem('dwd_date');
  localStorage.removeItem('dwd_date_range');
  localStorage.removeItem('dwd_selected_project');
  localStorage.removeItem('dwd_created_by');
  localStorage.removeItem('date_range');
  localStorage.removeItem('date');
  localStorage.removeItem('project');
  localStorage.removeItem('mysub_date_range');
  localStorage.removeItem('mysub_date');
  localStorage.removeItem('form_res_date_range');
  localStorage.removeItem('form_res_date');
  localStorage.removeItem(TIMESHEET_START_DATE_KEY);
  localStorage.removeItem(TIMESHEET_END_DATE_KEY);
};
